import type { FieldErrorsImpl, FieldValues, UseFormRegister } from 'react-hook-form'

import { useFormContext } from 'react-hook-form'

import { Checkbox as CheckboxUi } from 'src/ui/atoms/Checkbox'
import { Label } from '@/ui/atoms/Label'
import React from 'react'

import { Error } from '../Error'
import { Width } from '../Width'
import { ConsentFieldFormBlock } from '@/payload-types'
import RichText from '@/ui/components/RichText'
import { FormLabel } from '@/ui/atoms/FormLabel'

export const Consent: React.FC<
  ConsentFieldFormBlock & {
    errors: Partial<
      FieldErrorsImpl<{
        [x: string]: any
      }>
    >
    getValues: any
    register: UseFormRegister<FieldValues>
    setValue: any
  }
> = ({
  name,
  errors,
  label,
  register,
  required,
  privacyPolicyVersion,
  termsAndConditionsVersion,
}) => {
  const pattern = required ? /^true$/ : /^true|false$/
  const props = register(name, { required: required, pattern: pattern })
  const { setValue } = useFormContext()

  return (
    <Width>
      <div className="flex items-center gap-1">
        <CheckboxUi
          defaultChecked={false}
          value={'false'}
          id={name}
          {...props}
          onCheckedChange={(checked) => {
            setValue(props.name, checked)

            if (!checked) {
              setValue('privacyPolicyVersion', '')
              setValue('termsAndConditionsVersion', '')
            } else {
              setValue('privacyPolicyVersion', privacyPolicyVersion)
              setValue('termsAndConditionsVersion', termsAndConditionsVersion)
            }
          }}
          hasError={errors[name] ? true : false}
        />
        <FormLabel htmlFor={name}>
          <RichText
            data={label}
            className="!text-label-XS-regular text-text-subtle ms-1"
            variant="plain"
          />
        </FormLabel>
      </div>
      {errors[name] && <Error />}
    </Width>
  )
}
